<template>
  <el-dialog
    width="600px"
    :title="action === 'edit' ? $t('text.editRoute') : $t('text.addRoute')"
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
  >
    <el-form :model="form2" :rules="rules" ref="form2">
      <el-form-item :label="$t('text.merchantName')" :label-width="formLabelWidth" prop="appId">
        <el-select
          v-model="form2.appId"
          filterable
          :placeholder="$t('message.chooseOne')"
          :disabled="isDisabled"
        >
          <el-option key="0" :label="$t('option.null')" value="0"></el-option>
          <el-option
            v-for="merchant in merchantList"
            :label="merchant.value + '-' + merchant.name"
            :key="merchant.value"
            :value="merchant.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('text.forcedRoute')"
        prop="routeStatus"
        :label-width="formLabelWidth"
        v-if="ROLE_TYPE.isManager()"
      >
        <el-select
          v-model="form2.routeStatus"
          :placeholder="$t('message.chooseOne')"
          :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option key="" :label="$t('option.null')" value=""></el-option>
          <el-option :label="$t('routeStatus.01')" value="01"></el-option>
          <el-option :label="$t('routeStatus.00')" value="00"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('text.collectionChannel')"
        prop="channelId"
        :label-width="formLabelWidth"
        v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()
        "
      >
        <el-select
          v-model="form2.channelId"
          filterable
          :placeholder="$t('message.chooseOne')"
          :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option
            v-for="item in collectionOption"
            :key="item.channelId"
            :label="item.channelName"
            :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('text.collectionBKashChannel')"
          :label-width="formLabelWidth"
          prop="paymentBKashChannelId"
          v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()"
      ><el-input
          v-model="form2.paymentBKashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.collectionNagadChannel')"
          :label-width="formLabelWidth"
          prop="paymentNagadChannelId"
          v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()"
      ><el-input
          v-model="form2.paymentNagadChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.collectionRocketChannel')"
          :label-width="formLabelWidth"
          prop="paymentRocketChannelId"
          v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()"
      ><el-input
          v-model="form2.paymentRocketChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('text.disbursementChannel')"
        prop="withdrawChannelId"
        :label-width="formLabelWidth"
        v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()
        "
      >
        <el-select
          v-model="form2.withdrawChannelId"
          filterable
          :placeholder="$t('message.chooseOne')"
          :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option
            v-for="item in paymentOption"
            :key="item.channelId"
            :label="item.channelName"
            :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          :label="$t('text.disbursementBKashChannel')"
          :label-width="formLabelWidth"
          prop="transferBKashChannelId"
          v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()"
      ><el-input
          v-model="form2.transferBKashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.disbursementNagadChannel')"
          :label-width="formLabelWidth"
          prop="transferNagadChannelId"
          v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()"
      ><el-input
          v-model="form2.transferNagadChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('text.disbursementRocketChannel')"
          :label-width="formLabelWidth"
          prop="transferRocketChannelId"
          v-if="
          form2.routeStatus === '01' &&
          ROLE_TYPE.isManager()"
      ><el-input
          v-model="form2.transferRocketChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type = "info" @click="backupRoute(form2.routeId)">{{ $t('text.routeBackup') }}</el-button>
      <el-button type="warning" @click="restoreRoute((form2.routeId))">{{ $t('text.routeRestore') }}</el-button>
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="saveSystem" v-if="isButton"
        >{{ $t('text.confirm') }}</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },components: {
    ElCol,
    ElRow
  },
  name: "SystemEdit",
  props: {
    show: Boolean,
    value: Object,
    action: String
  },
  data() {
    return {
      dialogShow: this.show,
      groups: "",
      isButton: true,
      isDisabled: false,
      time: { start: "00:00", step: "00:01", end: "23:59" },
      isEdit: false,
      form2: {
        productId: "",
        agtId: "",
        channelId: "",
        paymentBKashChannelId: "",
        paymentNagadChannelId: "",
        paymentRocketChannelId: "",
        routeStatus: "00",
        deductionType: "",
        productPrice: "",
        routeWeight: "",
        timeStart: "",
        timeEnd: "",
        appId: "",
        withdrawChannelId: "",
        transferBKashChannelId: "",
        transferNagadChannelId: "",
        transferRocketChannelId: "",
        paymentChannelConfig: "",
        transferChannelConfig: "",
        forceUpdate: false
      },
      merchantList: [],
      channelInfoList: [],
      channelInfoListByProduct: [],
      productList: [],
      agtList: [],
      channelList: [],
      formLabelWidth: "120px",
      fromData: {},
      rules: {
        appId: [{ required: true, message: this.$t('message.appIdRequiredError'), trigger: "change" }],
        channelId: [{ required: true, message: this.$t('message.channelIdRequiredError') }],
        withdrawChannelId: [
          {
            required: true,
            message: this.$t('message.withdrawChannelIdRequiredError'),
            trigger: ["blur", "change"]
          }
        ],
        routeStatus: [
          {
            required: true,
            message: this.$t('message.routeStatusRequiredError'),
            trigger: ["blur", "change"]
          }
        ]
      },
      collectionOption: [],
      paymentOption: []
    };
  },
  methods: {
    init() {
      if (this.action === "edit") {
        // 解析 paymentChannelConfig
        try {
          if (this.value.paymentChannelConfig) {
            const config = typeof this.value.paymentChannelConfig === 'string'
                ? JSON.parse(this.value.paymentChannelConfig)
                : this.value.paymentChannelConfig;
            this.value.paymentBKashChannelId = config.bKash || config.bkash || "";
            this.value.paymentNagadChannelId = config.nagad || "";
            this.value.paymentRocketChannelId = config.rocket || "";
          }
        } catch (e) {
          console.error('Failed to parse paymentChannelConfig:', e);
        }

        // 解析 transferChannelConfig
        try {
          if (this.value.transferChannelConfig) {
            const config = typeof this.value.transferChannelConfig === 'string'
                ? JSON.parse(this.value.transferChannelConfig)
                : this.value.transferChannelConfig;

            this.value.transferBKashChannelId = config.bKash || config.bkash || "";
            this.value.transferNagadChannelId = config.nagad || "";
            this.value.transferRocketChannelId = config.rocket || "";
          }
        } catch (e) {
          console.error('Failed to parse transferChannelConfig:', e);
        }
        this.form2 = Object.assign({}, this.value);
      }

      this.$axios
        .get("/routeChannelInfo/selectByCondition", { params: {} })
        .then((res) => {
          res.data.map((item) => {
            // 解析每個 item 的 paymentChannelConfig
            try {
              if (item.paymentChannelConfig) {
                const config = typeof item.paymentChannelConfig === 'string'
                  ? JSON.parse(item.paymentChannelConfig)
                  : item.paymentChannelConfig;

                item.paymentBKashChannelId = config.bKash || config.bkash || "";
                item.paymentNagadChannelId = config.nagad || "";
                item.paymentRocketChannelId = config.rocket || "";
              }
            } catch (e) {
              console.error('Failed to parse item paymentChannelConfig:', e);
            }

            // 解析每個 item 的 transferChannelConfig
            try {
              if (item.transferChannelConfig) {
                const config = typeof item.transferChannelConfig === 'string'
                  ? JSON.parse(item.transferChannelConfig)
                  : item.transferChannelConfig;

                item.transferBKashChannelId = config.bKash || config.bkash || "";
                item.transferNagadChannelId = config.nagad || "";
                item.transferRocketChannelId = config.rocket || "";
              }
            } catch (e) {
              console.error('Failed to parse item transferChannelConfig:', e);
            }

            if (item.productId === "110") {
              this.collectionOption.push({
                channelName: item.channelName,
                channelId: item.channelId
              });
            }
            if (item.productId === "120") {
              this.paymentOption.push({
                channelName: item.channelName,
                channelId: item.channelId
              });
            }
          });
        });
    },
    closeDialog() {
      this.form2 = {
        productId: "",
        agtId: "",
        channelId: "",
        paymentBKashChannelId: "",
        paymentNagadChannelId: "",
        paymentRocketChannelId: "",
        routeStatus: "01",
        deductionType: "",
        productPrice: "",
        routeWeight: "",
        timeStart: "",
        timeEnd: "",
        appId: "",
        withdrawChannelId: "",
        transferBKashChannelId: "",
        transferNagadChannelId: "",
        transferRocketChannelId: ""
      };
      this.$refs["form2"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
      this.collectionOption = [];
      this.paymentOption = [];
    },
    getOptions() {
      this.$axios
        .get("/merchant/selectListForOption", { params: { hasAgent: 1 } })
        .then((res) => {
          this.merchantList = res.data;
        });
    },
    backupRoute(routeId) {
      let url = "/routeConfigInfo/routeConfigInfoBackup";
      this.axios.post(url, {
        routeId: routeId
      }).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
      });
    },
    restoreRoute(routeId) {
      let url = "/routeConfigInfo/routeConfigInfoRestore";
      this.axios.post(url, {
        routeId: routeId
      }).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: this.$t('text.prompt'),
            message: res.msg,
            type: "success"
          });
          this.$bus.$emit("refresh"); //通知刷新

          this.closeDialog();
        } else {
          this.$notify.error({
            title: this.$t('text.prompt'),
            message: res.msg
          });
        }
      });
    },
    saveSystem() {
      this.$refs["form2"].validate((valid) => {
        if (valid) {
          let url = "/routeConfigInfo/routeConfigInfoUpdate";
          if (this.action === "add") {
            url = "/routeConfigInfo/routeConfigInfoAdd";
          }
          const paymentChannelConfig = {
            bkash: this.form2.paymentBKashChannelId,
            nagad: this.form2.paymentNagadChannelId,
            rocket: this.form2.paymentRocketChannelId
          };

          const transferChannelConfig = {
            bkash: this.form2.transferBKashChannelId,
            nagad: this.form2.transferNagadChannelId,
            rocket: this.form2.transferRocketChannelId
          };

          this.form2.paymentChannelConfig = JSON.stringify(paymentChannelConfig);
          this.form2.transferChannelConfig = JSON.stringify(transferChannelConfig);
          this.form2.forceUpdate = false;

          this.axios.post(url, this.form2).then((res) => {
            if (res.code === 200) {
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: "success"
              });
              this.$bus.$emit("refresh"); //通知刷新

              this.closeDialog();
            } else if ((res.msg || '').includes('通道成本')) {
              const warningMessage = (res.msg || '').replace(/；/g, '<br/>');
              this.$confirm(
                  `<div style="line-height: 1.6; margin-bottom: 12px;">${warningMessage}</div><div>${this.$t('message.confirmForceOperate')}</div>`,
                  this.$t('text.prompt'),
                  {
                    confirmButtonText: this.$t('text.confirm'),
                    cancelButtonText: this.$t('text.cancel'),
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                  })
                  .then(() => {
                    this.form2.forceUpdate = true;
                    this.axios.post(url, this.form2).then((forceRes) => {
                      if (forceRes.code === 200) {
                        this.$notify({
                          title: this.$t('text.prompt'),
                          message: forceRes.msg,
                          type: "success"
                        });
                        this.$bus.$emit("refresh");
                        this.closeDialog();
                      } else {
                        this.form2.forceUpdate = false;
                        this.$notify.error({
                          title: this.$t('text.prompt'),
                          message: forceRes.msg
                        });
                      }
                    });
                  })
                  .catch(() => {
                    this.form2.forceUpdate = false;
                  });
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.getOptions();
  },
  mounted() {
    this.$bus.$on("refreshButton", (isButton) => {
      this.isButton = isButton;
    });
    this.$bus.$on("isDisabled", (isDisabled) => {
      this.isDisabled = isDisabled;
    });
    this.$bus.$on("dialogShow", (dialogShow) => {
      this.dialogShow = dialogShow;
    });
  }
};
</script>
